export const lifebuoy = {
  "v": "5.9.6",
  "fr": 60,
  "ip": 0,
  "op": 120,
  "w": 750,
  "h": 750,
  "nm": "Main render",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Layer 1",
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 100,
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [
            375,
            375,
            0
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [
            375,
            375,
            0
          ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [
            100,
            100,
            100
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [
                            -41.795,
                            -75.676
                          ],
                          [
                            75.676,
                            -41.795
                          ],
                          [
                            41.795,
                            75.676
                          ],
                          [
                            -75.676,
                            41.795
                          ]
                        ],
                        "o": [
                          [
                            41.795,
                            -75.676
                          ],
                          [
                            75.676,
                            41.795
                          ],
                          [
                            -41.795,
                            75.676
                          ],
                          [
                            -75.676,
                            -41.795
                          ]
                        ],
                        "v": [
                          [
                            0,
                            -75.676
                          ],
                          [
                            75.676,
                            0
                          ],
                          [
                            0,
                            75.676
                          ],
                          [
                            -75.676,
                            0
                          ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 10,
                    "s": [
                      {
                        "i": [
                          [
                            -46.745,
                            -23.596999999999998
                          ],
                          [
                            23.596999999999998,
                            -46.745
                          ],
                          [
                            46.745,
                            23.596999999999998
                          ],
                          [
                            -23.596999999999998,
                            46.745
                          ]
                        ],
                        "o": [
                          [
                            -4.920999999999999,
                            -52.131
                          ],
                          [
                            52.131,
                            -4.920999999999999
                          ],
                          [
                            4.920999999999999,
                            52.131
                          ],
                          [
                            -52.131,
                            4.920999999999999
                          ]
                        ],
                        "v": [
                          [
                            -25.833,
                            -37.864
                          ],
                          [
                            37.864,
                            -25.833
                          ],
                          [
                            25.833,
                            37.864
                          ],
                          [
                            -37.864,
                            25.833
                          ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 20,
                    "s": [
                      {
                        "i": [
                          [
                            -46.745,
                            -23.596999999999998
                          ],
                          [
                            23.596999999999998,
                            -46.745
                          ],
                          [
                            46.745,
                            23.596999999999998
                          ],
                          [
                            -23.596999999999998,
                            46.745
                          ]
                        ],
                        "o": [
                          [
                            -4.920999999999999,
                            -52.131
                          ],
                          [
                            52.131,
                            -4.920999999999999
                          ],
                          [
                            4.920999999999999,
                            52.131
                          ],
                          [
                            -52.131,
                            4.920999999999999
                          ]
                        ],
                        "v": [
                          [
                            -25.833,
                            -37.864
                          ],
                          [
                            37.864,
                            -25.833
                          ],
                          [
                            25.833,
                            37.864
                          ],
                          [
                            -37.864,
                            25.833
                          ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 30,
                    "s": [
                      {
                        "i": [
                          [
                            -32.444,
                            -90.683
                          ],
                          [
                            90.683,
                            -32.444
                          ],
                          [
                            32.444,
                            90.683
                          ],
                          [
                            -90.683,
                            32.444
                          ]
                        ],
                        "o": [
                          [
                            59.476,
                            -75.753
                          ],
                          [
                            75.753,
                            59.476
                          ],
                          [
                            -59.476,
                            75.753
                          ],
                          [
                            -75.753,
                            -59.476
                          ]
                        ],
                        "v": [
                          [
                            13.516,
                            -83.218
                          ],
                          [
                            83.218,
                            13.516
                          ],
                          [
                            -13.516,
                            83.218
                          ],
                          [
                            -83.218,
                            -13.516
                          ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 40,
                    "s": [
                      {
                        "i": [
                          [
                            -43.830000000000005,
                            -65.898
                          ],
                          [
                            65.899,
                            -43.830000000000005
                          ],
                          [
                            43.830000000000005,
                            65.899
                          ],
                          [
                            -65.898,
                            43.830000000000005
                          ]
                        ],
                        "o": [
                          [
                            32.436,
                            -72.19200000000001
                          ],
                          [
                            72.19300000000001,
                            32.436
                          ],
                          [
                            -32.436,
                            72.19300000000001
                          ],
                          [
                            -72.19200000000001,
                            -32.436
                          ]
                        ],
                        "v": [
                          [
                            -5.697,
                            -69.045
                          ],
                          [
                            69.046,
                            -5.697
                          ],
                          [
                            5.697,
                            69.046
                          ],
                          [
                            -69.045,
                            5.697
                          ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 50,
                    "s": [
                      {
                        "i": [
                          [
                            -41.795,
                            -75.676
                          ],
                          [
                            75.676,
                            -41.795
                          ],
                          [
                            41.795,
                            75.676
                          ],
                          [
                            -75.676,
                            41.795
                          ]
                        ],
                        "o": [
                          [
                            41.795,
                            -75.676
                          ],
                          [
                            75.676,
                            41.795
                          ],
                          [
                            -41.795,
                            75.676
                          ],
                          [
                            -75.676,
                            -41.795
                          ]
                        ],
                        "v": [
                          [
                            0,
                            -75.676
                          ],
                          [
                            75.676,
                            0
                          ],
                          [
                            0,
                            75.676
                          ],
                          [
                            -75.676,
                            0
                          ]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0,
                  1
                ],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 35,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  375,
                  375
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [
                            68.808,
                            -58.285
                          ],
                          [
                            -68.808,
                            58.285
                          ]
                        ],
                        "o": [
                          [
                            68.808,
                            -58.285
                          ],
                          [
                            -68.808,
                            58.285
                          ]
                        ],
                        "v": [
                          [
                            68.808,
                            -58.285
                          ],
                          [
                            -68.808,
                            58.285
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 10,
                    "s": [
                      {
                        "i": [
                          [
                            -86.949,
                            -40.631
                          ],
                          [
                            -116.01,
                            64.671
                          ]
                        ],
                        "o": [
                          [
                            -86.949,
                            -40.631
                          ],
                          [
                            -116.01,
                            64.671
                          ]
                        ],
                        "v": [
                          [
                            -86.949,
                            -40.631
                          ],
                          [
                            -116.01,
                            64.671
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 20,
                    "s": [
                      {
                        "i": [
                          [
                            -86.949,
                            -40.631
                          ],
                          [
                            -116.01,
                            64.671
                          ]
                        ],
                        "o": [
                          [
                            -86.949,
                            -40.631
                          ],
                          [
                            -116.01,
                            64.671
                          ]
                        ],
                        "v": [
                          [
                            -86.949,
                            -40.631
                          ],
                          [
                            -116.01,
                            64.671
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 30,
                    "s": [
                      {
                        "i": [
                          [
                            118.584,
                            -40.136
                          ],
                          [
                            -53.568,
                            63.472
                          ]
                        ],
                        "o": [
                          [
                            118.584,
                            -40.136
                          ],
                          [
                            -53.568,
                            63.472
                          ]
                        ],
                        "v": [
                          [
                            118.584,
                            -40.136
                          ],
                          [
                            -53.568,
                            63.472
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 40,
                    "s": [
                      {
                        "i": [
                          [
                            38.883,
                            -58.214
                          ],
                          [
                            -77.899,
                            58.504
                          ]
                        ],
                        "o": [
                          [
                            38.883,
                            -58.214
                          ],
                          [
                            -77.899,
                            58.504
                          ]
                        ],
                        "v": [
                          [
                            38.883,
                            -58.214
                          ],
                          [
                            -77.899,
                            58.504
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "t": 50,
                    "s": [
                      {
                        "i": [
                          [
                            68.808,
                            -58.285
                          ],
                          [
                            -68.808,
                            58.285
                          ]
                        ],
                        "o": [
                          [
                            68.808,
                            -58.285
                          ],
                          [
                            -68.808,
                            58.285
                          ]
                        ],
                        "v": [
                          [
                            68.808,
                            -58.285
                          ],
                          [
                            -68.808,
                            58.285
                          ]
                        ],
                        "c": false
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0,
                  1
                ],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 35,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  502.262,
                  263.999
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [
                            70.101,
                            -59.38
                          ],
                          [
                            -70.101,
                            59.38
                          ]
                        ],
                        "o": [
                          [
                            70.101,
                            -59.38
                          ],
                          [
                            -70.101,
                            59.38
                          ]
                        ],
                        "v": [
                          [
                            70.101,
                            -59.38
                          ],
                          [
                            -70.101,
                            59.38
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 10,
                    "s": [
                      {
                        "i": [
                          [
                            115.779,
                            -62.635
                          ],
                          [
                            86.172,
                            44.645
                          ]
                        ],
                        "o": [
                          [
                            115.779,
                            -62.635
                          ],
                          [
                            86.172,
                            44.645
                          ]
                        ],
                        "v": [
                          [
                            115.779,
                            -62.635
                          ],
                          [
                            86.172,
                            44.645
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 20,
                    "s": [
                      {
                        "i": [
                          [
                            115.779,
                            -62.635
                          ],
                          [
                            86.172,
                            44.645
                          ]
                        ],
                        "o": [
                          [
                            115.779,
                            -62.635
                          ],
                          [
                            86.172,
                            44.645
                          ]
                        ],
                        "v": [
                          [
                            115.779,
                            -62.635
                          ],
                          [
                            86.172,
                            44.645
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 30,
                    "s": [
                      {
                        "i": [
                          [
                            55.793,
                            -65.284
                          ],
                          [
                            -119.592,
                            40.27
                          ]
                        ],
                        "o": [
                          [
                            55.793,
                            -65.284
                          ],
                          [
                            -119.592,
                            40.27
                          ]
                        ],
                        "v": [
                          [
                            55.793,
                            -65.284
                          ],
                          [
                            -119.592,
                            40.27
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 40,
                    "s": [
                      {
                        "i": [
                          [
                            78.836,
                            -59.036
                          ],
                          [
                            -40.139,
                            59.873
                          ]
                        ],
                        "o": [
                          [
                            78.836,
                            -59.036
                          ],
                          [
                            -40.139,
                            59.873
                          ]
                        ],
                        "v": [
                          [
                            78.836,
                            -59.036
                          ],
                          [
                            -40.139,
                            59.873
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "t": 50,
                    "s": [
                      {
                        "i": [
                          [
                            70.101,
                            -59.38
                          ],
                          [
                            -70.101,
                            59.38
                          ]
                        ],
                        "o": [
                          [
                            70.101,
                            -59.38
                          ],
                          [
                            -70.101,
                            59.38
                          ]
                        ],
                        "v": [
                          [
                            70.101,
                            -59.38
                          ],
                          [
                            -70.101,
                            59.38
                          ]
                        ],
                        "c": false
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0,
                  1
                ],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 35,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  245.607,
                  481.403
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 3",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [
                            -63.482,
                            -62.937
                          ],
                          [
                            63.482,
                            62.937
                          ]
                        ],
                        "o": [
                          [
                            -63.482,
                            -62.937
                          ],
                          [
                            63.482,
                            62.937
                          ]
                        ],
                        "v": [
                          [
                            -63.482,
                            -62.937
                          ],
                          [
                            63.482,
                            62.937
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 10,
                    "s": [
                      {
                        "i": [
                          [
                            -33.903,
                            89.327
                          ],
                          [
                            72.59,
                            108.965
                          ]
                        ],
                        "o": [
                          [
                            -33.903,
                            89.327
                          ],
                          [
                            72.59,
                            108.965
                          ]
                        ],
                        "v": [
                          [
                            -33.903,
                            89.327
                          ],
                          [
                            72.59,
                            108.965
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 20,
                    "s": [
                      {
                        "i": [
                          [
                            -33.903,
                            89.327
                          ],
                          [
                            72.59,
                            108.965
                          ]
                        ],
                        "o": [
                          [
                            -33.903,
                            89.327
                          ],
                          [
                            72.59,
                            108.965
                          ]
                        ],
                        "v": [
                          [
                            -33.903,
                            89.327
                          ],
                          [
                            72.59,
                            108.965
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 30,
                    "s": [
                      {
                        "i": [
                          [
                            -49.466,
                            -113.454
                          ],
                          [
                            67.668,
                            47.641
                          ]
                        ],
                        "o": [
                          [
                            -49.466,
                            -113.454
                          ],
                          [
                            67.668,
                            47.641
                          ]
                        ],
                        "v": [
                          [
                            -49.466,
                            -113.454
                          ],
                          [
                            67.668,
                            47.641
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 40,
                    "s": [
                      {
                        "i": [
                          [
                            -61.074,
                            -33.424
                          ],
                          [
                            64.241,
                            71.862
                          ]
                        ],
                        "o": [
                          [
                            -61.074,
                            -33.424
                          ],
                          [
                            64.241,
                            71.862
                          ]
                        ],
                        "v": [
                          [
                            -61.074,
                            -33.424
                          ],
                          [
                            64.241,
                            71.862
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "t": 50,
                    "s": [
                      {
                        "i": [
                          [
                            -63.482,
                            -62.937
                          ],
                          [
                            63.482,
                            62.937
                          ]
                        ],
                        "o": [
                          [
                            -63.482,
                            -62.937
                          ],
                          [
                            63.482,
                            62.937
                          ]
                        ],
                        "v": [
                          [
                            -63.482,
                            -62.937
                          ],
                          [
                            63.482,
                            62.937
                          ]
                        ],
                        "c": false
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0,
                  1
                ],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 35,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  256.182,
                  257.75
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [
                            -64.302,
                            -63.72
                          ],
                          [
                            64.302,
                            63.72
                          ]
                        ],
                        "o": [
                          [
                            -64.302,
                            -63.72
                          ],
                          [
                            64.302,
                            63.72
                          ]
                        ],
                        "v": [
                          [
                            -64.302,
                            -63.72
                          ],
                          [
                            64.302,
                            63.72
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 10,
                    "s": [
                      {
                        "i": [
                          [
                            -72.782,
                            -108.723
                          ],
                          [
                            35.067,
                            -88.861
                          ]
                        ],
                        "o": [
                          [
                            -72.782,
                            -108.723
                          ],
                          [
                            35.067,
                            -88.861
                          ]
                        ],
                        "v": [
                          [
                            -72.782,
                            -108.723
                          ],
                          [
                            35.067,
                            -88.861
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 20,
                    "s": [
                      {
                        "i": [
                          [
                            -72.782,
                            -108.723
                          ],
                          [
                            35.067,
                            -88.861
                          ]
                        ],
                        "o": [
                          [
                            -72.782,
                            -108.723
                          ],
                          [
                            35.067,
                            -88.861
                          ]
                        ],
                        "v": [
                          [
                            -72.782,
                            -108.723
                          ],
                          [
                            35.067,
                            -88.861
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 30,
                    "s": [
                      {
                        "i": [
                          [
                            -68.524,
                            -48.829
                          ],
                          [
                            50.134,
                            114.281
                          ]
                        ],
                        "o": [
                          [
                            -68.524,
                            -48.829
                          ],
                          [
                            50.134,
                            114.281
                          ]
                        ],
                        "v": [
                          [
                            -68.524,
                            -48.829
                          ],
                          [
                            50.134,
                            114.281
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 40,
                    "s": [
                      {
                        "i": [
                          [
                            -64.964,
                            -72.437
                          ],
                          [
                            61.966,
                            34.154
                          ]
                        ],
                        "o": [
                          [
                            -64.964,
                            -72.437
                          ],
                          [
                            61.966,
                            34.154
                          ]
                        ],
                        "v": [
                          [
                            -64.964,
                            -72.437
                          ],
                          [
                            61.966,
                            34.154
                          ]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "t": 50,
                    "s": [
                      {
                        "i": [
                          [
                            -64.302,
                            -63.72
                          ],
                          [
                            64.302,
                            63.72
                          ]
                        ],
                        "o": [
                          [
                            -64.302,
                            -63.72
                          ],
                          [
                            64.302,
                            63.72
                          ]
                        ],
                        "v": [
                          [
                            -64.302,
                            -63.72
                          ],
                          [
                            64.302,
                            63.72
                          ]
                        ],
                        "c": false
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0,
                  1
                ],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 35,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  492.824,
                  492.22
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [
                            -143.155,
                            -259.206
                          ],
                          [
                            259.206,
                            -143.155
                          ],
                          [
                            143.155,
                            259.206
                          ],
                          [
                            -259.206,
                            143.155
                          ]
                        ],
                        "o": [
                          [
                            143.155,
                            -259.206
                          ],
                          [
                            259.206,
                            143.155
                          ],
                          [
                            -143.155,
                            259.206
                          ],
                          [
                            -259.206,
                            -143.155
                          ]
                        ],
                        "v": [
                          [
                            0,
                            -259.206
                          ],
                          [
                            259.206,
                            0
                          ],
                          [
                            0,
                            259.206
                          ],
                          [
                            -259.206,
                            0
                          ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 10,
                    "s": [
                      {
                        "i": [
                          [
                            -160.11,
                            -80.822
                          ],
                          [
                            80.822,
                            -160.11
                          ],
                          [
                            160.11,
                            80.822
                          ],
                          [
                            -80.822,
                            160.11
                          ]
                        ],
                        "o": [
                          [
                            -16.85799999999999,
                            -178.558
                          ],
                          [
                            178.558,
                            -16.85799999999999
                          ],
                          [
                            16.85799999999999,
                            178.558
                          ],
                          [
                            -178.558,
                            16.85799999999999
                          ]
                        ],
                        "v": [
                          [
                            -88.484,
                            -129.69
                          ],
                          [
                            129.69,
                            -88.484
                          ],
                          [
                            88.484,
                            129.69
                          ],
                          [
                            -129.69,
                            88.484
                          ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 20,
                    "s": [
                      {
                        "i": [
                          [
                            -160.11,
                            -80.822
                          ],
                          [
                            80.822,
                            -160.11
                          ],
                          [
                            160.11,
                            80.822
                          ],
                          [
                            -80.822,
                            160.11
                          ]
                        ],
                        "o": [
                          [
                            -16.85799999999999,
                            -178.558
                          ],
                          [
                            178.558,
                            -16.85799999999999
                          ],
                          [
                            16.85799999999999,
                            178.558
                          ],
                          [
                            -178.558,
                            16.85799999999999
                          ]
                        ],
                        "v": [
                          [
                            -88.484,
                            -129.69
                          ],
                          [
                            129.69,
                            -88.484
                          ],
                          [
                            88.484,
                            129.69
                          ],
                          [
                            -129.69,
                            88.484
                          ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 30,
                    "s": [
                      {
                        "i": [
                          [
                            -111.125,
                            -310.606
                          ],
                          [
                            310.606,
                            -111.126
                          ],
                          [
                            111.126,
                            310.606
                          ],
                          [
                            -310.606,
                            111.126
                          ]
                        ],
                        "o": [
                          [
                            203.719,
                            -259.46799999999996
                          ],
                          [
                            259.46799999999996,
                            203.718
                          ],
                          [
                            -203.718,
                            259.46799999999996
                          ],
                          [
                            -259.46799999999996,
                            -203.718
                          ]
                        ],
                        "v": [
                          [
                            46.297,
                            -285.037
                          ],
                          [
                            285.037,
                            46.296
                          ],
                          [
                            -46.296,
                            285.037
                          ],
                          [
                            -285.037,
                            -46.296
                          ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.667,
                      "y": 1
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 40,
                    "s": [
                      {
                        "i": [
                          [
                            -150.127,
                            -225.716
                          ],
                          [
                            225.716,
                            -150.127
                          ],
                          [
                            150.127,
                            225.716
                          ],
                          [
                            -225.716,
                            150.127
                          ]
                        ],
                        "o": [
                          [
                            111.097,
                            -247.272
                          ],
                          [
                            247.272,
                            111.097
                          ],
                          [
                            -111.097,
                            247.272
                          ],
                          [
                            -247.272,
                            -111.097
                          ]
                        ],
                        "v": [
                          [
                            -19.515,
                            -236.494
                          ],
                          [
                            236.494,
                            -19.515
                          ],
                          [
                            19.515,
                            236.494
                          ],
                          [
                            -236.494,
                            19.515
                          ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 50,
                    "s": [
                      {
                        "i": [
                          [
                            -143.155,
                            -259.206
                          ],
                          [
                            259.206,
                            -143.155
                          ],
                          [
                            143.155,
                            259.206
                          ],
                          [
                            -259.206,
                            143.155
                          ]
                        ],
                        "o": [
                          [
                            143.155,
                            -259.206
                          ],
                          [
                            259.206,
                            143.155
                          ],
                          [
                            -143.155,
                            259.206
                          ],
                          [
                            -259.206,
                            -143.155
                          ]
                        ],
                        "v": [
                          [
                            0,
                            -259.206
                          ],
                          [
                            259.206,
                            0
                          ],
                          [
                            0,
                            259.206
                          ],
                          [
                            -259.206,
                            0
                          ]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0,
                  1
                ],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 35,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  375,
                  375
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 6",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 0,
      "op": 180,
      "st": 0,
      "ct": 1,
      "bm": 0,
      "completed": true
    }
  ],
  "markers": [],
  "__complete": true
}